import { render, staticRenderFns } from "./SettlementOfComplaintsDashboard.vue?vue&type=template&id=4b7e5885&scoped=true&"
import script from "./SettlementOfComplaintsDashboard.vue?vue&type=script&lang=js&"
export * from "./SettlementOfComplaintsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7e5885",
  null
  
)

export default component.exports